import { handleRoute } from "../https";
import authClient from "../../app/auth/Auth";

const companyID = authClient.getCompanyId();

export async function findModels() {
  const res = await handleRoute({
    method: "get",
    path: `v1/companies/${companyID}/benefits`,
  });
  return res;
}

export async function findGiftCards() {
  const res = await handleRoute({
    method: "get",
    path: `v1/companies/${companyID}/gift-cards`,
  });
  return res;
}

export async function createBenefit(benefit) {
  const res = await handleRoute({
    method: "post",
    path: `v1/companies/${companyID}/benefits`,
    payload: benefit,
  });
  return res;
}

export async function createBenefitModel(benefit) {
  const res = await handleRoute({
    method: "post",
    path: `v2/companies/${companyID}/benefit-models`,
    payload: benefit,
  });
  return res;
}

export async function editBenefit(benefit) {
  const res = await handleRoute({
    method: "put",
    path: `v1/companies/${companyID}/benefits/${benefit.id}`,
    payload: benefit,
  });
  return res;
}

export async function editBenefitModel(benefitId, payload) {
  const res = await handleRoute({
    method: "patch",
    path: `v2/companies/${companyID}/benefit-models/${benefitId}`,
    payload,
  });
  return res;
}

export async function editBenefitV2({ benefitId, state, benefitType }) {
  const res = await handleRoute({
    method: "put",
    path: `v1/companies/${companyID}/benefit-models/${benefitId}/${benefitType}/product-config/state`,
    payload: { enabled: state },
  });
  return res;
}

export async function removeBenefit(benefitId) {
  const res = await handleRoute({
    method: "delete",
    path: `v1/companies/${companyID}/benefits/${benefitId}`,
  });
  return res;
}

export async function newRecurrentSubsidy({
  companyId,
  model,
  employees,
  confirmationRequired,
  generalParameters,
}) {
  const res = await handleRoute({
    method: "post",
    path: `v1/companies/${companyId}/benefits/${model.id}/recurrentSubsidy`,
    payload: { employees, confirmationRequired, generalParameters },
  });
  return res;
}

export async function deleteRecurrentSubsidy(companyId, model) {
  const res = await handleRoute({
    method: "delete",
    path: `v1/companies/${companyId}/benefits/${model.id}/recurrentSubsidy`,
  });
  return res;
}

export const createBenefitBag = async ({
  companyId,
  benefitPlanId,
  payload,
}) => {
  const res = await handleRoute({
    method: "post",
    path: `/v2/companies/${companyId}/benefit-plan/${benefitPlanId}/benefit-bag-configurations`,
    payload,
  });
  return res;
};

export const getEmployeeBenefitBag = async ({ companyId, employeeId }) => {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}/benefit-bags`,
  });
  return res;
};

export const editBenefitBag = async () => {
  // TODO: wire endpoint
  const res = await handleRoute({
    method: "put",
    path: "TBD",
    payload: {},
  });
  return res;
};

export const deleteBenefitBag = async ({
  companyId,
  benefitPlanId,
  benefitBagConfigId,
  notifyEmployees,
}) => {
  const res = await handleRoute({
    method: "delete",
    path: `/v1/companies/${companyId}/benefit-plan/${benefitPlanId}/benefit-bag/${benefitBagConfigId}`,
    payload: { notifyEmployees },
  });
  return res;
};

export const addEmployeesToModelThatHasBag = async ({
  companyId,
  benefitPlanId,
  benefitBagConfigId,
  consumableFrom,
  limitAmount,
  employeeIds,
}) => {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/benefit-plan/${benefitPlanId}/benefitBagConfigId/${benefitBagConfigId}/benefitBags`,
    payload: {
      consumableFrom,
      limitAmount,
      employeeIds,
    },
  });
  return res;
};
